import * as React from 'react';
import { RegularField, AggregatedField } from '../types';
import { useLocation } from 'react-router-dom';
import { getUrlOpenCase } from 'app/components/helpers';
import styles from './cell.scss';
import { DisplayLink } from 'ui';

interface RenderCellProps {
  cell: RegularField;
  index?: number;
}

export const RenderCell: React.FC<RenderCellProps> = ({ cell, index }) => {

  const cellClassName = [
    cell.columnType,
    ...((!!(cell.iconUrl || cell.bgColour) && [styles.iconColumn]) || [])
  ].join(' ');

  const valueClassName = [
    styles.text,
    ...(((!!cell.onClick || !!cell.url) && [styles.drillDownCol]) || [])
  ].join(' ');

  const icon = !!cell.iconUrl && <img src={cell.iconUrl} alt={cell.value} />;
  // Get current path and search params from react-router
  const location = useLocation();
  const currentPath = location.pathname;
  const searchParams = new URLSearchParams(location.search);

  const value = cell.url ?
  <DisplayLink className={valueClassName}
    url={getUrlOpenCase(Number(cell.value), currentPath, searchParams)} /> :
    <span className={valueClassName}>{cell.value}</span>;

  const colorBox = !cell.iconUrl && !!cell.bgColour && <div
    className={styles.colorBox}
    style={{ backgroundColor: cell.bgColour }} />;

  return <td key={index}
    className={cellClassName}
    title={cell.tooltip}
    onClick={cell.onClick}
    tabIndex={!!cell.onClick ? 0 : null}>
    {icon}
    {colorBox}
    {value}
  </td>;
};

export const renderAggregateCell = (cell: RegularField | AggregatedField) => {

  const aggregateCell = cell as AggregatedField;

  if (aggregateCell.values) {
    return <td title={cell.tooltip} className="aggregate-cell">
      {aggregateCell.values.map((f, i) => <React.Fragment key={i}><div
        className={styles.boxContainer}
        onClick={f.onClick}
        title={f.tooltip}>
        {!!f.iconUrl && <img src={f.iconUrl} />}
        {!f.iconUrl && !!f.bgColour && <div
          className={styles.colorBox}
          style={{ backgroundColor: f.bgColour }} />}
        {!f.iconUrl && !f.bgColour && <span>{f.value} </span>}
        {!!f.aggregatedValue && <span className={styles.drillDownCol}>{f.aggregatedValue}</span>}
      </div>{' '}</React.Fragment>)}
    </td>;
  }

  return <RenderCell cell={cell as RegularField} />; // Fallback to RenderCell for regular fields
};
